import { render, staticRenderFns } from "./BrbSelectableItem.vue?vue&type=template&id=ce902866&scoped=true&"
import script from "./BrbSelectableItem.vue?vue&type=script&lang=js&"
export * from "./BrbSelectableItem.vue?vue&type=script&lang=js&"
import style0 from "./BrbSelectableItem.vue?vue&type=style&index=0&id=ce902866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce902866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce902866')) {
      api.createRecord('ce902866', component.options)
    } else {
      api.reload('ce902866', component.options)
    }
    module.hot.accept("./BrbSelectableItem.vue?vue&type=template&id=ce902866&scoped=true&", function () {
      api.rerender('ce902866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbSelectableItem.vue"
export default component.exports